import { Controller } from "@hotwired/stimulus"

// Backs a Bootstrap dropdown used as a custom "styled select" (e.g. the
// name-display-size picker, where each option is an actual <h1>-<h6> tag
// rather than plain text). Picking an item copies its own markup into the
// toggle button -- not a separate value->display lookup table -- so the
// toggle always mirrors exactly what was clicked. The hidden field holds
// the real value the form submits; the server already renders the
// toggle's initial content and the hidden field's initial value from the
// resource's saved setting, so this only needs to react to clicks.
export default class extends Controller {
  static targets = ["toggle", "hidden"]

  select(event) {
    event.preventDefault()
    this.hiddenTarget.value = event.currentTarget.dataset.value
    this.toggleTarget.innerHTML = event.currentTarget.innerHTML
    this.element.classList.add("filled")
  }
}
